// src/lib/tutor/sage-open-signal.ts
//
// "Sage was just opened." A tiny module-level channel, like active-question.ts:
// TutorFab (mounted in the app shell) announces each time its panel opens, and
// a surface that needs to know listens.
//
// The listener today is "Fix this mistake" (src/components/practice/
// FixThisMistake.tsx): a fresh question counts as solved INDEPENDENTLY only if
// the student didn't open Sage for it (docs/fix-this-mistake-spec.md,
// requirement 4). The server also counts any Sage call made while the question
// was up; this covers opening Sage and reading without asking.

type Listener = () => void

const listeners = new Set<Listener>()

/** Announce that the Sage panel just opened. */
export function markSageOpened(): void {
  for (const l of listeners) l()
}

/** Subscribe. Returns an unsubscribe fn. */
export function onSageOpened(cb: Listener): () => void {
  listeners.add(cb)
  return () => {
    listeners.delete(cb)
  }
}

/** Test-only reset. */
export function __resetSageOpenSignal(): void {
  listeners.clear()
}
